import React from 'react';
export function Footer() {
  return <footer className="bg-[#2A1E17] py-8 text-center text-beige/50 text-sm border-t border-white/5" data-id="element-89">
      <div className="max-w-6xl mx-auto px-4" data-id="element-90">
        <p className="mb-4 font-serif text-lg text-beige/80" data-id="element-91">
          Irreconocible en 30 Días
        </p>
        <p data-id="element-92">© {new Date().getFullYear()} Todos los derechos reservados.</p>
        <div className="flex justify-center gap-4 mt-4 text-xs" data-id="element-93">
          <a href="#" className="hover:text-beige transition-colors" data-id="element-94">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-beige transition-colors" data-id="element-95">
            Políticas de Privacidad
          </a>
        </div>
        <p className="mt-6 text-[10px] opacity-50 max-w-2xl mx-auto" data-id="element-96">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}